import React from "react";
import { PageBuilderFaresMosaicFragment } from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";

import { graphql } from "gatsby";
import { isPresent } from "src/utils/checks";
import StaticFaresMosaic from "components/fare/StaticFaresMosaic/StaticFaresMosaic";
import StaticMiniFaresMosaic from "components/fare/StaticFaresMosaic/StaticMiniFaresMosaic";
import { FareCardProps } from "components/fare/FareCard/FareCard";

export type PageBuilderFaresMosaicProps = PageBuilderFaresMosaicFragment;

const PageBuilderFaresMosaic: React.FC<
  React.PropsWithChildren<PageBuilderFaresMosaicProps>
> = ({
  heading,
  inclusionsContent = [],
  fares = [],
  cancellationPolicyModalContent,
  expeditionInclusionModalContent,
  variant
}) => {
  const farePages = fares.filter(isPresent);
  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      {variant == "mini" ? (
        <StaticMiniFaresMosaic
          fares={farePages}
          inclusionsContent={inclusionsContent.filter(isPresent)}
        />
      ) : (
        <StaticFaresMosaic
          fares={farePages}
          inclusionsContent={inclusionsContent.filter(isPresent)}
          cancellationPolicyModalContent={cancellationPolicyModalContent!}
          cardVariant={(variant as FareCardProps["variant"]) || "expanded"}
          expeditionInclusionModalContent={expeditionInclusionModalContent}
        />
      )}
    </React.Fragment>
  );
};

export default PageBuilderFaresMosaic;

export const fragments = graphql`
  fragment PageBuilderFaresMosaic on SanityFaresMosaic {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    fares {
      ...FareMosaicCard
    }

    variant

    inclusionsContent {
      ...InfographicCardInclusionContent
    }

    cancellationPolicyModalContent {
      ...CancellationPolicyModalContent
    }

    expeditionInclusionModalContent {
      ...ExpeditionInclusionModalContent
    }
  }
`;
